var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDpd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 88,
    viewBox: "0 324.5 153.5 67.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D50033",
    d: "M28.8 326.4c.6-.3 1.2-.8 1.8-.6l1.7 1 20 10.7 4.4 2.5-8.2 4.8-9.9 5.8c-.5.2-.5.9-.4 1.4 0 .6-.2 1.4.4 1.9l1.8 1c.3.2.6 0 1-.1l15.3-9 1.4-.8v28.5c0 .7-.4 1.5-1 1.9l-25.2 14.8c-.8.6-1.9.8-2.7.3a27332 27332 0 00-25.7-15.1c-.6-.4-1-1-1.2-1.7V345l25 14.4c.2.1.5.4.5.7v21.4c0 .5.3.8.7 1l1.5.8c.6.1 1.2-.3 1.7-.6s1.1-.6 1-1.2v-24c.1-.5-.2-.8-.6-1L3.8 340l25-13.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#424043",
    d: "M92.4 340h6.3v33.7c-1.3.4-2.7.5-4.1.8-3.4.3-7 .6-10.3-.3-2.6-.6-5-2.1-6.6-4.4-1.9-2.5-2.4-5.9-2-9 .3-2.8 1.4-5.6 3.5-7.5 2-1.8 4.7-2.8 7.4-3 2-.2 4-.2 5.8.6V340m-7.8 16.8a5.8 5.8 0 00-2.4 4c-.4 2.1 0 4.4 1.2 6.1 1.1 1.4 2.8 2.1 4.5 2.4 1.5.1 3 0 4.5-.2v-12.6c-.9-.4-1.8-.6-2.7-.7-1.7-.2-3.6 0-5.1 1zm59.8-16.8h6.4v33.7c-3.4.8-6.9 1.1-10.3 1-3 0-6.3-.8-8.7-2.7-2-1.6-3.4-4-3.9-6.5-.5-3-.3-6 .9-8.7a10.9 10.9 0 014.7-5 14 14 0 0111-.9V340m-8.7 17.5a6.8 6.8 0 00-1.7 4.8c0 1.6.3 3.2 1.3 4.5 1 1.4 2.7 2.2 4.4 2.4 1.5.2 3.1.2 4.6-.1v-12.6c-1.3-.6-2.8-.8-4.3-.7-1.5 0-3.1.6-4.3 1.7zm-33.5-5.4c3.4-1.3 7-2 10.6-2 3 0 5.9.8 8.2 2.5 2.1 1.5 3.6 3.8 4.1 6.3.4 1.6.4 3.2.3 4.7a12 12 0 01-3.5 8 13.8 13.8 0 01-9.9 3.2v-5.5c1.8-.1 3.6-.5 5-1.7a6.8 6.8 0 002-5.5c0-2-.8-4-2.4-5a7.4 7.4 0 00-4.3-1.2c-1.2 0-2.5.1-3.7.5v27.4h-6.4V352z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpd);
export default __webpack_public_path__ + "static/media/dpd.e32756ec5d21392e757beec461a8acb2.svg";
export { ForwardRef as ReactComponent };